<template>
    <div>
      <Print_barcode_onshelf/>
    </div>
</template>
  
  <script>
  import Print_barcode_onshelf from "@/components/adminArin/pos_system/warehouse/printbarcodeonshelf/Print_barcode_onshelf";
  export default {
    name: "printbarcodeonshelf",
    components: {
        Print_barcode_onshelf
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  